import eventManagement from '@/api/event-management'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  searchEven: '',
  currentPage: 1,
  edit_data: {},
}

export const getters = {}
export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_SEARCH_EVEN(state, value) {
    state.searchEven = value
  },
  RESET_CURRENT_PAGE(state) {
    state.currentPage = 1
  }
}
export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        searchEven: context.state.searchEven

      },
      attrubutes
    )
    return eventManagement.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async fetchEvent({ commit }, id) {
    try {
      const data = await eventManagement.find(id)
      commit('SET_EDIT_DATA', data)
    } catch (error) {
      console.error('Failed to load event:', error)
      throw error
    }
  },

  store(context, data) {
    return eventManagement.store(data)
  },

  update(context, data) {
    return eventManagement.update(data)
  },
  destroy(context, id) {
    return eventManagement.destroy(id)
  },

  removeFileUploaded(context, attributes) {
    return eventManagement.removeFile({
      params: attributes
    })
  },

  generateQr(context, data) {
    return eventManagement.generateQr({
      params: {
        event_mgt_id: data.event_mgt_id
      }
    })
  },
  generateTicket(context, data) {
    return eventManagement.generateTicket({
      params: {
        event_mgt_id: data.event_mgt_id
      }
    })
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await eventManagement.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  eventManagementDetailExcel(context, data) {
    return eventManagement.eventManagementDetailExcel(data)
  },
}
